import {ReadApiCall} from '../../reader/message/ReadApiCall';
import {ReadFile} from '../../reader/message/ReadFile';
import {ReadSql} from '../../reader/message/ReadSql';

export class CnxReader {
api: ReadApiCall;
file: ReadFile;
kind: string;
sql: ReadSql;
}

